module.exports = __webpack_public_path__ + "static/media/Simple.98e55c18.png";